module.exports = __webpack_public_path__ + "media/images/advert-img-03-194a96a866f2f55d85be3cfbfe10704d.png";